// no itx for this file

import Logger from "../Logger";
import { DeviceClasses } from "../models/DeviceClasses";
const logger = new Logger();

export default class VersionManagement {
  static updateItemFromOldVersion(version: number, item: any) {
    if (version == 1) {
      logger.log("VersionManagement:", item.className);
      switch (item.className) {
        case "Device":
        case "Button":
        case "Actor": {
          if (!item.classification) {
            if (item.channelType == "Sensor") {
              item.classification = DeviceClasses.SensorNew;
            } else if (item.channelType == "DecentralActor") {
              item.classification = DeviceClasses.DecentralActor;
            }
          }
          break;
        }

        case "Sensor": {
          item.className = "Button";
          break;
        }

        case "SensorChannel": {
          item.className = "ButtonChannel";
          break;
        }

        case "Connection": {
          if (item.type == "Sensor") {
            item.type = "Button";
          }
          break;
        }

        case "TemplateGroup": {
          if (item.templateGroupType.name == "Sensor") {
            item.templateGroupType.name = "Button";
            item.templateGroupType.templateGroupType = DeviceClasses.Button;
          }
          break;
        }
      }
    }
  }
}
